import { Link } from "react-router";
import { RoutePaths } from "../routes";

function WishlistFooter() {
  return (
    <div className="p-10">
      <Link to={RoutePaths.privacyPolicy}>Privacy policy</Link>
    </div>
  );
}

export default WishlistFooter;
